import Carousel from './components/Carousel.js';
import Header from './components/Header.js';
import Scroller from './components/Scroller.js';
import TextAnim from './components/TextAnim.js';
import Modale from './components/Modale.js';

export default class ComponentFactory {
  constructor() {
    this.componentList = {
      Header,
      Carousel,
      Scroller,
      TextAnim,
      Modale,
    };

    this.init();
  }
  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const component = components[i];
      console.log(component);
      const componentName = component.dataset.component;

      if (this.componentList[componentName]) {
        new this.componentList[componentName](component);
      } else {
        console.log(
          `Error: La composante ${componentName} n'existe pas espèce de loser`,
        );
      }
    }
  }
}
